import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./styles.css";
import "./i18n";
import App from "./App";
import { ToastProvider } from "./components/common/ToastProvider";
import UpdateNotifier from "./components/common/UpdateNotifier";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { logVersion, APP_VERSION, BUILD_COMMIT, BUILD_DATE } from "./version";

logVersion();

// ── Sentry — inicializar antes del render ────────────────────────
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV || 'development',
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
  });

  // Telemetría: una sola muestra por sesión con la versión del cliente.
  // Permite ver en Sentry la distribución de BUILD_COMMIT en uso (clientes
  // atrasados / legacy SW). Defensive: no romper el arranque si algo falla.
  try {
    Sentry.setTag('client_build_commit', BUILD_COMMIT || 'dev');
    Sentry.setTag('client_build_date', BUILD_DATE || 'unknown');
    Sentry.setTag('app_version', APP_VERSION || 'unknown');
    Sentry.setTag('has_service_worker', 'serviceWorker' in navigator ? 'yes' : 'no');
    Sentry.setTag('environment', process.env.REACT_APP_ENV || 'development');
    Sentry.captureMessage('client_boot', 'info');
  } catch (_) { /* no-op */ }
}

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <ToastProvider>
      {/* Escucha eventos de update del SW y muestra toast con botón "Actualizar" */}
      <UpdateNotifier />
      <App />
    </ToastProvider>
  </StrictMode>
);

// Registrar el Service Worker para PWA + push notifications.
// Se registra desde acá (después del render) en lugar de App.js para evitar
// doble registro en StrictMode (donde useEffect corre 2 veces en dev).
//
// CAMBIO 15/5/2026: el handler de update ya no recarga automáticamente.
// Cuando hay nueva versión, dispara un CustomEvent que el componente
// <UpdateNotifier /> escucha y muestra como toast. El reload solo ocurre
// si el usuario hace click en "Actualizar".
serviceWorkerRegistration.register({
  onSuccess: () => console.log("[Condor360] PWA lista para uso offline"),
  onUpdate:  () => console.log("[Condor360] Nueva versión disponible — toast mostrado"),
});
